import PickOneRecord from 'slotworks/model/gameplay/records/pick-one-record';

export default class PickOneTreasureBonusRecord extends PickOneRecord {
    is_complete: boolean;
    triggered: boolean;
    rounds: number;
    pickedOptions: { [key: string]: number };
    total_win_cash: number;
}



// WEBPACK FOOTER //
// ./src/integration/pickone-treasure-bonus-record.ts